type CashierAssets = { scriptUrl: string; styleUrl: string };

type Manifest = Record<string, { file: string }>;

const manifests = new Map<string, Promise<CashierAssets>>();

export const loadCashierAssets = (host: string) => {
  const cached = manifests.get(host);
  if (cached) {
    return cached;
  }

  const assets = fetch(`${host}/dist/manifest.json`)
    .then((res) => res.json() as Promise<Manifest>)
    .then((manifest) => ({
      scriptUrl: `${host}/dist/${manifest["index.html"].file}`,
      styleUrl: `${host}/dist/${manifest["style.css"].file}`,
    }));
  assets.catch(() => manifests.delete(host));
  manifests.set(host, assets);
  return assets;
};

const appendPreloadLink = (href: string, rel: string, as?: string) => {
  if (document.head.querySelector(`link[href="${href}"]`)) {
    return;
  }
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  if (as) {
    link.as = as;
  }
  if (rel === "modulepreload") {
    link.crossOrigin = "";
  }
  document.head.appendChild(link);
};

export const preloadCashierAssets = (host: string) =>
  loadCashierAssets(host)
    .then(({ scriptUrl, styleUrl }) => {
      appendPreloadLink(scriptUrl, "modulepreload");
      appendPreloadLink(styleUrl, "preload", "style");
    })
    .catch(() => {});
